/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useRoom } from '../../../hooks/useRoom';
import { useRootSelector } from '../../../hooks/useRootSelector';
import { RouterStates } from '../../../definitions/RouterStates';
import { isNotaryRoute, goTo } from '@utils/routing';

export const useCallEndRedirect = () => {
  const { roomId } = useRoom();
  const location = useLocation();
  const callDetails = useRootSelector(state => state.callDetails);
  const isNotary = isNotaryRoute(location.pathname);
  const isCallEnded = !!callDetails && (callDetails.status === 'CLOSED' || callDetails.status === 'COMPLETED');

  useEffect(() => {
    if (isCallEnded) {
      goTo(isNotary ? RouterStates.NOTARY_ROOM_FINISH : RouterStates.PARTICIPANT_ROOM_FINISH, { roomId });
    }
  }, [callDetails, isNotary, roomId]);
};
